import { computed } from 'vue';
import useMetaContext from './useMetaContext';

export default function useUSARegion() {
  const context = useMetaContext();

  return computed(() => context.value.regionCode === 'US');
}
